/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateSparzeitUmbuchungDto } from '../../models/create-sparzeit-umbuchung-dto';
import { SparzeitUmbuchungDto } from '../../models/sparzeit-umbuchung-dto';

export interface CreateSparzeitUmbuchung$Json$Params {
  
    /**
     * Daten der Sparzeit Umbuchung
     */
    body?: CreateSparzeitUmbuchungDto
}

export function createSparzeitUmbuchung$Json(http: HttpClient, rootUrl: string, params?: CreateSparzeitUmbuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SparzeitUmbuchungDto>> {
  const rb = new RequestBuilder(rootUrl, createSparzeitUmbuchung$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SparzeitUmbuchungDto>;
    })
  );
}

createSparzeitUmbuchung$Json.PATH = '/v1/sparzeitumbuchung/create';
